export default [
  {
    id: '5a1db47d-3593-6114-9071-d2a0299e152b',
    name: 'build-floor',
    path: 'build-floor',
    meta: {
      title: '建筑楼层管理',
      tabnab: false,
    },
    children: [
      {
        id: 'bb8ffc5e-0c97-e441-05f9-e761f7fc63ca',
        name: 'build-management',
        path: 'build-management',
        component: () => {
          return import('../views/buildFloor/BuildManagement')
        },
        meta: {
          title: '建筑管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '4ccc73d6-6c3f-4e4e-a0d7-f3e7d07af5d2',
        name: 'build-management-vulkan',
        path: 'build-management-vulkan',
        component: () => {
          return import('../views/buildFloor/BuildManagementVulkan')
        },
        meta: {
          title: '建筑管理5.0',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '67457745-2B8F-4ADD-A9C1-396E503A4827',
        name: 'draw-build',
        path: 'draw-build',
        component: () => {
          return import('../views/buildFloor/DrawBuild')
        },
        meta: {
          title: '建筑绘制',
          hidden: true,
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '59d27e81-97ea-46cd-b726-55d0a19223a7',
        name: 'draw-build-vulkan',
        path: 'draw-build-vulkan',
        component: () => {
          return import('../views/buildFloor/DrawBuildVulkan')
        },
        meta: {
          title: '建筑绘制5.0',
          hidden: true,
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '75a05cef-5eab-dee9-4f49-ef093c9067f4',
        name: 'floor-management',
        path: 'floor-management',
        component: () => {
          return import('../views/buildFloor/FloorManagement')
        },
        meta: {
          title: '楼层管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            correlation: {
              id: 4,
              name: 'correlation',
              desc: '关联',
              access: true,
            },
          },
        },
      },
      {
        id: '492feb37-ee63-4d9d-9069-9dd4d1ed7482',
        name: 'floor-management-vulkan',
        path: 'floor-management-vulkan',
        component: () => {
          return import('../views/buildFloor/FloorManagementVulkan')
        },
        meta: {
          title: '楼层管理5.0',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            correlation: {
              id: 4,
              name: 'correlation',
              desc: '关联',
              access: true,
            },
          },
        },
      },
      {
        id: '67457745-2B9F-4AED-A8C1-496E553A4845',
        name: 'draw-floor',
        path: 'draw-floor',
        component: () => {
          return import('../views/buildFloor/DrawFloor')
        },
        meta: {
          title: '楼层绘制',
          hidden: true,
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '813c6ef0-e45a-439e-9c25-a6eb92eddbd2',
        name: 'draw-floor-vulkan',
        path: 'draw-floor-vulkan',
        component: () => {
          return import('../views/buildFloor/DrawFloorVulkan')
        },
        meta: {
          title: '楼层绘制5.0',
          hidden: true,
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
